import type { FaireProductEntity } from "../../entity_types/product";

export const p_3hd3sdxam3: FaireProductEntity = {
  token: "p_3hd3sdxam3",
  type: "product",
  name: "Butter Dish with Lid 6.5\"L w/ Butter Knife Dragonfly Design (4/32)",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/c8a30cf161435834ec8561c3766ee80ba22340df1b80cb951e384def7b362b89.png",
  galleryImageUrls: [],
  priceDollars: 10,
  description: "Size: 6.5\"L x 3.8\"W x 3\"H\n\nMaterial: Ceramic with Bamboo Lid\n\nCase Pack: 32\n\nOrigin: China\n",
  tags: [],
  msrpDollars: 22.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:47.808Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
